import React from 'react';

const SvgFileUpload = props => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 32 32">
    <path
      d="M27.586 12.712a6.504 6.504 0 0 0-7.932-3.946 9 9 0 0 0-16.652 4.537A6.002 6.002 0 0 0 0 18.5c0 3.312 2.688 6 6 6h6v-2H5.997a4.001 4.001 0 0 1-.91-7.896 7 7 0 0 1 13.615-3.129 4.5 4.5 0 0 1 7.271 3.025h.03a4 4 0 0 1 0 8H20v2h6c3.312 0 6-2.693 6-6a6.002 6.002 0 0 0-4.414-5.788z"
      fill="#222"
    />
    <path fill="#222" d="M16 13.5l-5 6h3v8h4v-8h3z" />
  </svg>
);

export { SvgFileUpload };



// WEBPACK FOOTER //
// ./src/components/Svg/Svg.js